import template from './scheduling-widget.html';
import './scheduling-widget.scss';
import cssVariables from './config/cssVariables';
import fonts from './config/fonts';
import reminder from './config/reminder';
import theme from './config/theme';
import { noop } from 'lodash';

export default angular
  .module('doxy.realtime.components.scheduling.widget', [])
  .component('schedulingWidget', {
    template,
    bindings: {
      hide: '&',
      currentPerson: '<',
      user: '<',
    },
    controller: function ($timeout, roomHelpersFactory) {
      const that = this;

      const close = function () {
        $timeout(() => {
          that.hide();
        });
      };

      const room = roomHelpersFactory.getRoom();

      const initData = {
        reminder,
        theme,
        cssVariables,
        fonts,
        onClose: close,
        onTrack: noop,
        smsConsent: this.user.smsVerified,
        smsConsentEnabled: true,
        serviceName: 'doxyme',
        emailFrom: 'Doxy.me Reminders',
        logo: 'https://doxy.me/assets/icons/legacy/logo-horizontal-black.png',
        clientData: {
          name: this.currentPerson.state.username,
        },
        providerData: {
          name: this.user.displayName,
          roomUrl: roomHelpersFactory.getRoomUrl(room),
        },
      };

      this.popupRadius = initData.cssVariables['cardBorderRadius'] || '0';

      $timeout(() => {
        window.Adherely.default.render(initData, '#scheduling');
      });
    },
  }).name;
